/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core'
import { baseExportToggle, clickable, exportContainer, exportContainerOpen, exportIconContainer, exportIconStyle, exportOpenIconStyle, exportToggleButtonClosed, exportToggleButtonOpen } from './ExpansiveFileExportBtn.style'
import { FileExportIcon } from '../Icons/Icons'
import { Button } from '../Buttons/Buttons'
import { identity } from '@bonitour/common-functions'

export function ExpansiveFileExportBtn ({
  toggleVisible = identity,
  isVisible = false
}) {
  return (
    <div css={exportIconContainer}>
      <div onClick={toggleVisible} css={[clickable, isVisible ? exportContainerOpen : exportContainer]}>
        <Button
          className="exportButton"
          css={[isVisible ? exportToggleButtonOpen : exportToggleButtonClosed, baseExportToggle]}
        >
          <FileExportIcon css={[isVisible ? exportOpenIconStyle : exportIconStyle]} />
            Exportar
        </Button>
      </div>
    </div>
  )
}
